import React from 'react';
import './MedalIcon.css';

/**
 * Returns the base path under which static images are served.
 *
 * Tied to the app's asset mount (PUBLIC_URL, e.g. '/stats') rather than the
 * current route — the SPA is served at root but assets stay under /stats.
 * @returns {string} Base path like '/stats', or '' when unset.
 */
function getBasePath() {
  return process.env.PUBLIC_URL || '';
}

/**
 * Renders a medal icon — static PNG image if available, emoji fallback.
 * Images served from /images/achievements/{id}.png.
 * @param {Object} props
 * @param {string} props.id - Achievement ID for image lookup.
 * @param {string} props.emoji - Fallback emoji icon.
 * @param {number} [props.size=40] - Icon size in pixels.
 * @param {string} [props.rarity] - Rarity class (legendary/epic/rare/common/locked).
 */
export default function MedalIcon({ id, emoji, size = 40, rarity = 'common' }) {
  const basePath = getBasePath();
  const imageSrc = `${basePath}/images/achievements/${id}.png`;

  return (
    <span className={`medal-icon-img medal-icon-${rarity}`} style={{ width: size, height: size }}>
      <img
        src={imageSrc}
        alt={id}
        width={size}
        height={size}
        onError={(e) => {
          e.target.style.display = 'none';
          e.target.nextSibling && (e.target.nextSibling.style.display = 'inline');
        }}
      />
      <span className="medal-icon-emoji-fallback" style={{ fontSize: size * 0.7, display: 'none' }}>{emoji}</span>
    </span>
  );
}
